/**
 * Corporate Gifts landing page — interactions
 * ---------------------------------------------------------------------------
 * 1. Catalog tier tabs
 * 2. RFQ chip selectors (single-select, writes to a hidden input)
 * 3. RFQ two-step form + Formspark submit
 *
 * Formspark submission mirrors assets/modal-form-handler.js: JSON POST to
 * https://submit-form.com/{id}, with the same dataLayer events so GA4 and the
 * Meta pixel treat this like every other lead form on the site.
 */
(function () {
  'use strict';

  /* ---------------------------------------------------------------- tabs */
  function initTiers(root) {
    var nav = root.querySelector('[data-cg-tiers]');
    if (!nav) return;
    var buttons = nav.querySelectorAll('[data-cg-tier]');
    var panels = root.querySelectorAll('[data-cg-panel]');

    nav.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cg-tier]');
      if (!btn) return;
      var key = btn.getAttribute('data-cg-tier');

      buttons.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-cg-panel') === key);
      });
    });
  }

  /* --------------------------------------------------------------- chips */
  function initChips(scope) {
    scope.querySelectorAll('[data-cg-chips]').forEach(function (group) {
      var target = group.getAttribute('data-cg-chips');
      var input = scope.querySelector('input[name="' + target + '"]');
      group.addEventListener('click', function (e) {
        var chip = e.target.closest('.cg-chip');
        if (!chip) return;
        group.querySelectorAll('.cg-chip').forEach(function (c) {
          c.classList.toggle('is-active', c === chip);
          c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
        });
        if (input) input.value = chip.getAttribute('data-value') || chip.textContent.trim();
      });
    });
  }

  /* ---------------------------------------------------------------- form */
  function initForm(root) {
    var form = root.querySelector('[data-cg-form]');
    if (!form) return;

    var endpoint = form.getAttribute('data-endpoint');
    var steps = form.querySelectorAll('[data-cg-step]');
    var bars = form.querySelectorAll('[data-cg-prog] i');
    var label = form.querySelector('[data-cg-prog-label]');
    var errorBox = form.querySelector('[data-cg-error]');
    var labels = JSON.parse(form.getAttribute('data-step-labels') || '[]');
    var current = 0;

    // scrollIntoView must NOT run on the initial render — the form sits near the
    // bottom of the page, so scrolling it into view on load drags the visitor
    // straight past the hero. Only scroll when the user moves between steps.
    function show(i, scroll) {
      current = i;
      steps.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
      bars.forEach(function (b, n) { b.classList.toggle('is-active', n <= i); });
      if (label && labels[i]) label.textContent = labels[i];
      if (scroll) form.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    function validate(stepEl) {
      var ok = true;
      stepEl.querySelectorAll('[required]').forEach(function (f) {
        if (!f.value || (f.type === 'email' && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(f.value))) {
          f.style.borderColor = 'var(--red)';
          ok = false;
        } else {
          f.style.borderColor = '';
        }
      });
      return ok;
    }

    function setError(msg) {
      if (!errorBox) return;
      errorBox.textContent = msg || '';
      errorBox.classList.toggle('is-visible', !!msg);
    }

    form.addEventListener('click', function (e) {
      if (e.target.closest('[data-cg-next]')) {
        e.preventDefault();
        setError('');
        if (validate(steps[current])) show(Math.min(current + 1, steps.length - 1), true);
      }
      if (e.target.closest('[data-cg-back]')) {
        e.preventDefault();
        setError('');
        show(Math.max(current - 1, 0), true);
      }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      setError('');
      if (!validate(steps[current])) return;

      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = '<span>Sending…</span>'; }

      var payload = {};
      new FormData(form).forEach(function (v, k) { payload[k] = v; });

      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'form_submit',
          form_name: 'corporate_gifts_rfq',
          inquiry_type: 'corporate_gifts_quote',
          lead_type: 'private',
          page_category: 'corporate_gifts',
          page_location: window.location.href
        });
      }

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          var done = form.querySelector('[data-cg-done]');
          steps.forEach(function (s) { s.classList.remove('is-active'); });
          if (done) done.classList.add('is-active');
          bars.forEach(function (b) { b.classList.add('is-active'); });
          if (label) label.textContent = 'Received';
          if (window.dataLayer) {
            window.dataLayer.push({
              event: 'form_success',
              form_name: 'corporate_gifts_rfq',
              inquiry_type: 'corporate_gifts_quote',
              lead_type: 'private',
              page_category: 'corporate_gifts',
              page_location: window.location.href
            });
          }
        })
        .catch(function (err) {
          setError("That didn't send. Email info@kraftstories.com or call (650) 460-2411 and we'll pick it up from there.");
          if (btn) { btn.disabled = false; btn.innerHTML = original; }
          if (window.dataLayer) {
            window.dataLayer.push({
              event: 'form_error',
              form_name: 'corporate_gifts_rfq',
              error_message: String(err && err.message)
            });
          }
        });
    });

    show(0, false);
  }

  /* ---------------------------------------------------------------- boot */
  function boot() {
    document.querySelectorAll('[data-cg-catalog]').forEach(initTiers);
    document.querySelectorAll('[data-cg-rfq]').forEach(function (root) {
      initChips(root);
      initForm(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify theme editor re-renders sections without a full page load.
  document.addEventListener('shopify:section:load', boot);
})();
